import { api } from './api'
import type { EventName, EventProps } from '../../../shared/events.ts'

/**
 * Отправка событий аналитики.
 *
 * Копим и шлём пачкой: дёргать сеть на каждое нажатие незачем, а на слабой
 * связи это ещё и заметно. Отправка намеренно «тихая» — любая ошибка здесь
 * не должна портить человеку гадание, поэтому отказ просто проглатывается.
 */

const FLUSH_DELAY_MS = 4000
const QUEUE_MAX = 40

interface Queued {
  name: EventName
  ts: number
  props?: EventProps
}

let queue: Queued[] = []
let timer: ReturnType<typeof setTimeout> | null = null

function flush(): void {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  if (!queue.length) return

  const batch = queue
  queue = []
  api.sendEvents(batch).catch(() => {
    // Событие — не данные пользователя: потерять его не страшно, а копить
    // бесконечно в надежде на сеть значит однажды отправить мусор за неделю.
  })
}

export function track(name: EventName, props?: EventProps): void {
  queue.push({ name, ts: Date.now(), props })

  // Очередь не должна расти без предела: если сеть недоступна, старые
  // события всё равно потеряют смысл.
  if (queue.length >= QUEUE_MAX) {
    flush()
    return
  }
  if (!timer) timer = setTimeout(flush, FLUSH_DELAY_MS)
}

/**
 * Досылает накопленное, когда приложение уходит в фон.
 *
 * Мини-приложение закрывают резко, и без этого терялись бы как раз самые
 * интересные события — те, после которых человек ушёл.
 */
export function startAnalytics(): void {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })
  window.addEventListener('pagehide', flush)
}
